import AddIcon from '@mui/icons-material/Add';
import { Box, Stack, Typography, useMediaQuery } from '@mui/material';
import { Suspense, useState, useTransition } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorScreen from '../../../core-components/theme/components/ErrorScreen';
import SearchBox from '../../../core-components/theme/components/Searchbox/Searchbox';
import Theme from '../../../core-components/theme/theme';
import Loader from '../../../globalComponents/loader/DPLoader';
import DataLoggerTable from './DataLoggerTable';
import Button from '../../../core-components/theme/components/Button/Button';
import AddDataLoggerDialog from './AddDataLoggerDialog';
import DataLoggerConfigurationDialog from './DataLoggerConfigurationDialog';

export default function DataLoggerList() {
  const [searchString, setSearchString] = useState('');
  const [isPending, startTransition] = useTransition();
  const isTablet = useMediaQuery(Theme.breakpoints.down('md'));
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const [isConfigDialogOpen, setIsConfigDialogOpen] = useState(false);
  const [configDialogData, setConfigDialogData] = useState<{ serialNumber?: string; id?: string } | null>(null);

  const handleAddDataLogger = () => {
    setIsAddDialogOpen(true);
  };

  const handleAddDialogClose = () => {
    setIsAddDialogOpen(false);
  };

  const handleConfigDialogClose = () => {
    setIsConfigDialogOpen(false);
    setConfigDialogData(null);
  };

  const handleAddSuccess = (data: { serialNumber: string }) => {
    setConfigDialogData({ serialNumber: data.serialNumber });
    setIsConfigDialogOpen(true);
  };

  const handleEditClick = (id: string) => {
    setConfigDialogData({ id });
    setIsConfigDialogOpen(true);
  };

  const handleSearch = (value: string) => {
    startTransition(() => {
      setSearchString(value);
    });
  };

  return (
    <>
    <Stack direction="column" spacing={3}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="title">
          Data Loggers
        </Typography>
          <Button
            onClick={handleAddDataLogger}
            aria-label="Add a new data logger"
          >
            <Stack direction="row" alignItems="center" gap={2}>
              <AddIcon />
              {!isTablet && (
                'Create Data Logger'
              )}
            </Stack>
          </Button>
      </Stack>

      <SearchBox
        placeholder="Search Data Logger"
        onSearch={value => handleSearch(value)}
        onClear={() => handleSearch('')}
      />

      <Box width="100%">
        <ErrorBoundary fallback={<ErrorScreen />}>
          <Suspense fallback={<Loader height="40vh" />}>
            <DataLoggerTable 
              isPending={isPending} 
              searchString={searchString} 
              onEditClick={handleEditClick}
            />
          </Suspense>
        </ErrorBoundary>
      </Box>

      {isAddDialogOpen && (
      <AddDataLoggerDialog
        open={isAddDialogOpen}
        onClose={handleAddDialogClose}
        onSuccess={handleAddSuccess}
      />
      )}
      {isConfigDialogOpen && (
      <DataLoggerConfigurationDialog
        key={configDialogData?.id || 'new'}
        open={isConfigDialogOpen}
        onClose={handleConfigDialogClose}
        initialData={configDialogData || undefined}
      />
      )}
    </Stack>
    </>
  );
}
